export enum ProjectStatus {
  ALL = '',
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export interface Project {
  id: number;
  accountNumber: string;
  code: string;
  description: string;
  endDate: string;
  startDate: string;
  firstName: string;
  lastName: string;
  name: string;
  owner: string;
}
